module.exports = __webpack_public_path__ + "img/65.3.TP.fa9be4cb.png";